<template>
    <v-container>
        <v-label>{{$t('event.create')}}</v-label>
        <v-form ref="form"
                v-model="isFormValid">
            <v-container>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('event.name')"
                                  :placeholder="$t('event.name')"
                                  v-model="event.name"
                                  :rules="nameRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-menu ref="startDateMenu"
                            v-model="showStartDatePicker"
                            :close-on-content-click="false"
                            :return-value.sync="event.start_date"
                            transition="scale-transition"
                            offset-y>
                        <template v-slot:activator="{ on }">
                            <v-text-field outlined
                                          v-model="event.start_date"
                                          :label="$t('event.start_date')"
                                          :placeholder="$t('event.start_date')"
                                          prepend-inner-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="event.start_date" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="showStartDatePicker = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.startDateMenu.save(event.start_date)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-row>
                <v-row>
                    <v-menu ref="endDateMenu"
                            v-model="showEndDatePicker"
                            :close-on-content-click="false"
                            :return-value.sync="event.end_date"
                            transition="scale-transition"
                            offset-y>
                        <template v-slot:activator="{ on }">
                            <v-text-field outlined
                                          v-model="event.end_date"
                                          :label="$t('event.end_date')"
                                          :placeholder="$t('event.end_date')"
                                          prepend-inner-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="event.end_date" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="showEndDatePicker = false">{{$t('cancel')}}</v-btn>
                            <v-btn text color="primary" @click="$refs.endDateMenu.save(event.end_date)">{{$t('ok')}}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-row>
                <v-row>
                    <v-select outlined
                                clearable
                                :label="$t('event.companyId')"
                                :placeholder="$t('event.companyId')"
                                :items="companyOptions"
                                v-model="event.companyId"
                                :rules="companyRules">
                    </v-select>
                </v-row>
            </v-container>
        </v-form>
        <v-row>
            <v-col>
                <v-btn color="primary" @click="saveEvent" :disabled="!isFormValid">
                    {{$t('event.create')}}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {computed, ref} from '@vue/composition-api'
    import {useFind} from "feathers-vuex";

    export default {
        name: 'EventAdd',
        setup(props, {root}) {
            const {Event, Company} = root.$FeathersVuex.api;
            const event = new Event({
                companyId: root.$store.state.prefilledCompanyId
            });

            const nameRules = ref([
                value => !!value || 'Required',
            ]);

            const showStartDatePicker = ref(false);
            const showEndDatePicker = ref(false);

            const eventIdRules = ref([
                value => !!value || 'Required',
            ]);

            const companyParams = computed(() => {
                return {
                    query: {
                        $sort: {
                            name: 1,
                        }
                    }
                }
            });
            const companyData = useFind({model: Company, params: companyParams});
            const companyOptions = computed(() => {
                return companyData.items.value.map(c => {
                    return {text: c.name, value: c.id}
                });
            });
            const companyRules = ref([
                value => !!value || 'Required',
            ]);

            const isFormValid = ref(false);

            const saveEvent = () => {
                event.save().then(() => {
                    root.$router.replace({name: 'event-list'});
                }, root.$handleFeatherError.bind(root));
            };

            return {
                event,
                nameRules,
                showStartDatePicker,
                showEndDatePicker,
                eventIdRules,
                companyOptions,
                companyRules,
                isFormValid,
                saveEvent,
            }
        },
        computed: {
            loggedInUser() {
                return this.$store.state.auth.user;
            },
        },
    }
</script>